import React from 'react'
import styled from '@emotion/styled'

type WithChildren<T = {}> = T & { children?: React.ReactNode }

const Content = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export function HorizontalFlex({ children }: WithChildren) {
  return <Content>
    {children}
  </Content>
}
